import { useEffect, useState } from "react";

/**
 * The value, once it has stopped changing for `delayMs`.
 *
 * For the rail's server search (H6, 20 Ekim 2026): the URL's `?q=` moves on every keystroke, and
 * asking `GET /chat/messages/search` for «i», «ir», «irs», «irsa» … would spend the 60/min search
 * budget on words nobody meant. The local filter stays instant; only the server waits.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return settled;
}
